<script setup lang="ts">
definePageMeta({ prerender: true })

const { data: page } = await useAsyncData('eula', () => queryCollection('eula').first())

useSeoMeta({
  description: () => page.value?.description,
  ogDescription: () => page.value?.description,
  ogTitle: () => page.value?.title,
  title: () => page.value?.title,
})

defineOgImageComponent('Default', {
  description: () => page.value?.description ?? '',
  eyebrow: 'signalfire.games / legal',
  title: 'EULA',
})

const siteConfig = useSiteConfig()
useSchemaOrg([
  ...(page.value?.lastUpdated
    ? [ defineWebPage({ dateModified: page.value.lastUpdated }) ]
    : []),
  defineBreadcrumb({
    itemListElement: [
      { item: siteConfig.url, name: 'Home' },
      { item: `${siteConfig.url}/eula/`, name: 'End-User License Agreement' },
    ],
  }),
])
</script>

<template>
  <SfgPaper v-if="page">
    <article class="mx-auto max-w-3xl">
      <SfgEyebrow variant="outline">
        Legal
      </SfgEyebrow>
      <SfgHeading :level="1" class="mt-5 mb-10">
        {{ page.title }}
      </SfgHeading>
      <div class="sfg-prose max-w-none font-body text-body">
        <ContentRenderer :value="page"/>
      </div>
    </article>
  </SfgPaper>
</template>
